<template>
  <div v-cloak v-if="loggedIn" id="page-wrapper">
    <!--EplNewPageHeader  :activeLink="'home'"></EplNewPageHeader-->
    <div class="container content-wrap">
      <!--div class="container"-->
      <div class="col-xs-12 content">
        <div class="row">
          <NewDashboardSlider v-if="promotions.length" :content="promotions"></NewDashboardSlider>
        </div>
        <div class="row">
          <div class="col-md-7 padding-0">
            <NewDashboardSlider
              v-if="smallSliderPromotions.length"
              :content="smallSliderPromotions"
            ></NewDashboardSlider>
          </div>
          <div class="col-md-5 padding-0">
            <Merchants />
          </div>
        </div>
      </div>
      <MobileNav :activeLink="'merchants'" class="visible-xs"></MobileNav>
    </div>
  </div>
</template>

<script>
import NewDashboardSlider from "./NewDashboardSlider/index";
import MobileNav from "./MobileNav/index";
import Merchants from "../components/EplNewMerchants/index";
import { mapGetters } from "vuex";
export default {
  name: "V2Dashboard",
  data() {
    return {
      promotions: [{ logoUrl: "/static/images/Banner.jpg" }],
      smallSliderPromotions: [
        { logoUrl: "/static/images/img1.jpg" },
        { logoUrl: "/static/images/img2.jpg" },
        { logoUrl: "/static/images/img3.jpg" },
        { logoUrl: "/static/images/img4.jpg" }
      ]
    };
  },
  computed: {
    ...mapGetters(["categoriesDashboard", "loggedIn", "userPromotionV3"])
  },
  components: { MobileNav, NewDashboardSlider, Merchants },
  methods: {}
};
</script>
<style scoped lang="scss">
@import "../assets/sass/variables";
#page-wrap {
  background: #ffffff;
  .content-wrap {
    padding: 0px;
  }
}

.content-section {
  background-color: #ffffff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-top: -10px;
  overflow: hidden;
  padding: 0;
  @media screen and (min-width: $md) {
    border-radius: 10px;
    margin-top: 0;
    min-height: 650px;
  }
  @media screen and (min-width: $md) {
    border-radius: 0px;
    background: white;
  }
  @media screen and (max-width: $md) {
    margin-top: 0;
    margin-bottom: 40px;
  }
}

.mt-10 {
  margin-top: 10px;
}

.padding-0 {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/EplNewDashboardFooter.vue